// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-role{padding:0 56px}.select-role--header{margin-bottom:20px}.select-role--body{max-width:272px;margin:0 auto}.select-role--body .ui-button:not(:last-child){margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
